import { isCanceledRequest } from 'helper/crmTaskErrors';

export { isCanceledRequest };

/**
 * The text to show for a failed prospection call. `text` is the text of
 * useText('prospection'); an unknown or missing errorCode gives errors.generic.
 */
export const prospectionErrorText = (text, error) => {
  const code = error?.response?.data?.errorCode;
  const codeText = code ? text(`errors.${code}`) : '';
  return codeText || text('errors.generic');
};
